export default __webpack_public_path__ + "static/HairFree-Hero-Desktop-v2-ebbf77d0326004d9381042027ee3c95f.webp";